module.exports = __webpack_public_path__ + "img/Picture6.88761355.png";